/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type {
  AtsIntegrationResponse,
  KomboConnectLinkResponse,
  MessageResponse,
} from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getKombo = () => {
  /**
   * Handles kombo get ats integrations
   * @summary Get ATS Integrations
   */
  const komboHandleKomboGetAtsIntegrations = (
    options?: SecondParameter<typeof axiosInstance<AtsIntegrationResponse[]>>
  ) => {
    return axiosInstance<AtsIntegrationResponse[]>(
      { url: `/kombo/get_ats_integrations`, method: 'POST' },
      options
    );
  };
  /**
   * Handles kombo force sync
   * @summary Force Kombo Sync
   */
  const komboHandleKomboForceSync = (
    options?: SecondParameter<typeof axiosInstance<MessageResponse>>
  ) => {
    return axiosInstance<MessageResponse>(
      { url: `/kombo/force_sync`, method: 'POST' },
      options
    );
  };
  /**
   * Handles kombo get sync status
   * @summary Get Kombo Sync Status
   */
  const komboHandleKomboGetSyncStatus = (
    options?: SecondParameter<typeof axiosInstance<MessageResponse>>
  ) => {
    return axiosInstance<MessageResponse>(
      { url: `/kombo/get_sync_status`, method: 'POST' },
      options
    );
  };
  /**
   * Handles kombo create connect link
   * @summary Create Kombo Connect Link
   */
  const komboHandleKomboCreateConnectLink = (
    options?: SecondParameter<typeof axiosInstance<KomboConnectLinkResponse>>
  ) => {
    return axiosInstance<KomboConnectLinkResponse>(
      { url: `/kombo/create_connect_link`, method: 'POST' },
      options
    );
  };
  return {
    komboHandleKomboGetAtsIntegrations,
    komboHandleKomboForceSync,
    komboHandleKomboGetSyncStatus,
    komboHandleKomboCreateConnectLink,
  };
};
export type KomboHandleKomboGetAtsIntegrationsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getKombo>['komboHandleKomboGetAtsIntegrations']
    >
  >
>;
export type KomboHandleKomboForceSyncResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getKombo>['komboHandleKomboForceSync']>>
>;
export type KomboHandleKomboGetSyncStatusResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getKombo>['komboHandleKomboGetSyncStatus']>
  >
>;
export type KomboHandleKomboCreateConnectLinkResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getKombo>['komboHandleKomboCreateConnectLink']>
  >
>;
